import styled, { css } from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const SIZING = {
    maxWidth: 1296,
    minHeight: 761,
    smallHorizontal: 16,
    verticalPadding: 16,
    largeHorizontal: 24,
};

export const DefaultPageBackground = styled.div<{ $hasExternalBackground: boolean }>`
    ${({ $hasExternalBackground }) =>
        // if the background is defined externally, then we don't set a background-color. Otherwise, we ALWAYS want to
        // use the Dark Theme's secondary surface color (to match up with Deltatre) regardless of the page's theme.
        !$hasExternalBackground &&
        css`
            background-color: ${BaseStyle.DarkTheme.Surface.secondary};
        `};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`;

export const DefaultPageContainer = styled.div<{
    $hasExternalBackground: boolean;
    $useSecondarySurfaceColorForBackground?: boolean;
    $isWebview?: boolean;
}>`
    background-color: ${({ theme, $useSecondarySurfaceColorForBackground }) =>
        $useSecondarySurfaceColorForBackground ? theme.Surface.secondary : theme.Surface.primary};
    max-width: ${SIZING.maxWidth}px;
    ${({ $isWebview }) =>
        $isWebview
            ? ''
            : css`
                  min-height: ${SIZING.minHeight}px;
              `}
    width: 100%;
    z-index: 1;

    ${({ $hasExternalBackground }) => {
        if ($hasExternalBackground) {
            return css`
                padding: ${SIZING.verticalPadding}px 0;
            `;
        }

        return css`
            padding: ${SIZING.verticalPadding}px ${SIZING.smallHorizontal}px;

            ${BaseStyle.Mixins.screenSizes.extraLarge} {
                padding: ${SIZING.verticalPadding}px ${SIZING.largeHorizontal}px;
            }
        `;
    }}
`;

export const TwoColumnPageContainer = styled.div`
    background: ${({ theme }) => theme.Surface.primary};
    min-height: ${SIZING.minHeight}px;
`;
